import React from 'react';

import type { MatchQuery } from '@confluence/route/entry-points/matchUrl';
import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection';
import { HOME } from '@confluence/named-routes/entry-points/routes';

export function RedirectToHomeWithQuery(extra: MatchQuery) {
	const redirectComponent = ({ query }: RouteMatch) => (
		<Redirection name={HOME.name} params={{ query: { ...query, ...extra } }} />
	);
	redirectComponent.NAVIGATION_PARAMS = () => false;
	return redirectComponent;
}
